/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-12 16:39:37
 */
import { defHttp } from "../utils/http/axios";

const Api = {
    Login: "/sys/tenant/login",
    phoneLogin: "/sys/phoneLogin",
    Logout: "/sys/logout",
    GetUserInfo: "/sys/tenant/userInfo",
    // 获取系统权限
    // 1、查询用户拥有的按钮/表单访问权限
    // 2、所有权限
    // 3、系统安全模式
    GetPermCode: "/sys/permission/getPermCode",
    //新加的获取图形验证码的接口
    getInputCode: "/sys/randomImage",
    //获取短信验证码的接口
    getCaptcha: "/sys/sms",
    //注册接口
    registerApi: "/sys/user/register",
    //校验用户接口
    checkOnlyUser: "/sys/user/checkOnlyUser",
    //SSO登录校验
    validateCasLogin: "/sys/cas/client/validateLogin",
    //校验手机号
    phoneVerify: "/sys/user/phoneVerification",
    //修改密码
    passwordChange: "/sys/password/change",
    //第三方登录
    thirdLogin: "/sys/thirdLogin/getLoginUser",
    //第三方登录
    getThirdCaptcha: "/sys/thirdSms",
    //获取二维码信息
    getLoginQrcode: "/sys/getLoginQrcode",
    //监控二维码扫描状态
    getQrcodeToken: "/sys/getQrcodeToken",
    getRoles: "/sys/user/roles",
    getAllPermissions: "/sys/permissions/cat",
    getTenantPermissions: "/sys/permissions/cat/tenant",
    getAuthorizedPermissions: "/sys/user/permissions/authorized/cat",
    getTenant: "/sys/user/tenant",
    getTeacherInviteUrl: "/sys/invite/teacher",
    //邀请链接
    getVerificationSummary: "/sys/invite/verification/summary",
    userInviteLinkList: "/cat/invite/user",
    teacherInviteLinkList: "/sys/invite/list",
    userInviteData: "/cat/invite/user/data",
    invitedUserList: "/sys/invite/users",
    acceptTeacherInvite: "/cat/invite/user/accept",
    inviteTeacherRegister: "/cat/invite/user/register",
    //手机验证码
    smsRequire: "/sys/sms",
    //管理用户
    getNonFrozenUserList: "/sys/users/nonFreeze",
    getStudentList: "/sys/students",
    getFreezedUserList: "/sys/users/freeze",
    freezeUser: "/sys/user/freeze",
    unseal: "/sys/user/unseal",
    teacherVerificationModify: "/sys/teacher/verification/modify",
    changeUserRole: "/sys/user/role/modify",
    getRoleAssignDesc: "/sys/role/desc",
    applyRole: "/sys/role/apply",
};

export function loginApi(params) {
    return defHttp.post({ url: Api.Login, params }, { isTransformResponse: false,formatDate: false });
}

export function doLogout() {
    return defHttp.get({ url: Api.Logout });
}

export async function getUserInfo() {
    const res = await defHttp.get({ url: Api.GetUserInfo }, {});
    return res;
}

export function updateUserInfo(params) {
    return defHttp.post({ url: Api.GetUserInfo, params }, {});
}

export function getRoles() {
    return defHttp.get({ url: Api.getRoles }, {});
}

export function getAllPermissions() {
    return defHttp.get({ url: Api.getAllPermissions }, {});
}

export function getTenantPermissions() {
    return defHttp.get({ url: Api.getTenantPermissions }, {});
}

export function getAuthorizedPermissions() {
    return defHttp.get({ url: Api.getAuthorizedPermissions }, {});
}

export function getTenant() {
    return defHttp.get({ url: Api.getTenant }, {});
}

export function getTeacherInviteUrl() {
    return defHttp.get({ url: Api.getTeacherInviteUrl }, {});
}

export async function getMenu() {}

export async function getVerificationSummary() {
    return defHttp.get({ url: Api.getVerificationSummary }, {});
}

export async function getInviteList(params) {
    return defHttp.get({ url: Api.teacherInviteLinkList, params }, {});
}

export async function createInvite(params) {
    return defHttp.post({ url: Api.userInviteLinkList, params }, {});
}

export async function queryInvitedUserList(params) {
    return defHttp.get({ url: Api.invitedUserList, params }, {});
}

export async function queryInviteData(params) {
    return defHttp.get({ url: Api.userInviteData, params });
}

export const SMS_MODE = {
    login: "0",
    register: "1",
    forgot: "2",
};
export async function requireSms(mobile, smsmode) {
    return defHttp.post({ url: Api.smsRequire, params: { mobile, smsmode } }, {});
}

export function acceptTeacherInvite(params) {
    return defHttp.post({ url: Api.acceptTeacherInvite, params }, {});
}

export function inviteTeacherRegister(params) {
    return defHttp.post({ url: Api.inviteTeacherRegister, params }, {});
}

export async function getNonFrozenUserList(params) {
    return defHttp.get({ url: Api.getNonFrozenUserList, params }, {});
}

export async function getStudentList(params) {
    return defHttp.get({ url: Api.getStudentList, params }, {});
}

export async function getFreezedUserList(params) {
    return defHttp.get({ url: Api.getFreezedUserList, params }, {});
}

export async function freezeUser(params) {
    return defHttp.post({ url: Api.freezeUser, params }, {});
}

export async function unseal(params) {
    return defHttp.post({ url: Api.unseal, params }, {});
}

export async function teacherVerificationModify(params) {
    return defHttp.post({ url: Api.teacherVerificationModify, params }, {});
}

export async function changeUserRole(params) {
    return defHttp.post({ url: Api.changeUserRole, params }, {});
}

export function phoneVerification(params) {
    return defHttp.post({ url: Api.phoneVerify, params }, {});
}

export function changePassword(params) {
    return defHttp.post({ url: Api.passwordChange, params }, {});
}

export function getRoleAssignDesc(params) {
    return defHttp.get({ url: Api.getRoleAssignDesc, params }, {});
}

export function applyRole(params) {
    return defHttp.post({ url: Api.applyRole, params }, {});
}
